// extracted by mini-css-extract-plugin
module.exports = {"root":"BigList-module--root--2zjKW","list":"BigList-module--list--3LeRs","item":"BigList-module--item--1JvDz"};